import { useEffect, useState } from "react";
import { app } from "@microsoft/teams-js";
import { api } from '../../index';
import { useNavigate } from "react-router-dom";
import Spinner from "../../Components/Spinner/Spinner";
import * as microsoftTeams from "@microsoft/teams-js";
import { DOMAIN } from "../../Constants";

let saveQueue: (id: any) => void;

function Config() {
	const [selected, setSelected] = useState(null);
	const [queues, setQueues] = useState([]);
	const [themeColor, setThemeColor] = useState('light');
	const navigate = useNavigate();

	useEffect(() => {
		if(api.isLoggedIn()) {
			const user = api.getUser();

			api.calls.user.queue.browse(user.id)
			.then((r: any) => setQueues(r.data));

			app.getContext().then(async (context) => {
				await microsoftTeams.app.initialize();
				setThemeColor(context.app.theme === 'default' ? 'light' : 'dark');

				saveQueue = (id: any) => {
					microsoftTeams.pages.config.registerOnSaveHandler((saveEvent: any) => {
						const configPromise = microsoftTeams.pages.config.setConfig({
							websiteUrl: DOMAIN,
							contentUrl: `${DOMAIN}/collaborative/${id}`,
							entityId: "grayIconTab12345ff45-34-ds344-dfhg3-343434",
							suggestedDisplayName: "Queue"
						});

						configPromise
						.then(() => {saveEvent.notifySuccess()})
						.catch(() => {saveEvent.notifyFailure("failure message")});
					});
				}
			})
		} else {
			navigate("/login");
		}
		// eslint-disable-next-line
	}, []);

	if(queues.length === 0 ) {
		return <span className='loading-spinner'>
			<Spinner themeType={themeColor} />
		</span>
	}

	queues.sort((a: any, b: any) => a.name.localeCompare(b.name))

	return <div className="config">
		{queues.map((q: any, index:any) => <input
			type="button"
			key={q.id}
			className={`button ${selected === index ? 'selected' : ''}`}
			value={q.name}
			onClick={() => {
				microsoftTeams.pages.config.setValidityState(true);
				saveQueue(q.id);
				setSelected((selected) => (selected === index ? null : index))
			}}
		/>)}
	</div>
}

export default Config;
